
import * as http from './base'

/**
 * 登陆
 * @param {object} data 
 */
const home = () => {
  return http.fetchApi('/pages')
}
const aboutDetail = () => {
  return http.fetchApi('/aboutDetail')
}
const getWebConfigDetail = () => {
  return http.fetchApi('/webConfigDetail')
}
const getWebMenuList = () => {
  return http.fetchApi('/webMenuList')
}

export { home,aboutDetail,getWebConfigDetail,getWebMenuList }


// WEBPACK FOOTER //
// ./src/http/admin.js